<div class="access-denied-container">
  <div class="lock"></div>
  <div class="message">
    <h1>Access to this page is restricted</h1>
    <p>Please check with the site admin if you believe this is a mistake.</p>
  </div>
  <button [routerLink]="'/' + routes.home" class="home-btn">Go Home</button>
</div>
